/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MuDataProcessingJoinersCountryIntervalDriver,
    MuDataProcessingJoinersCountryIntervalDriverFromJSON,
    MuDataProcessingJoinersCountryIntervalDriverFromJSONTyped,
    MuDataProcessingJoinersCountryIntervalDriverToJSON,
} from './';

/**
 * 
 * @export
 * @interface MuDataProcessingJoinersCountryIntervalManual
 */
export interface MuDataProcessingJoinersCountryIntervalManual {
    /**
     * 
     * @type {MuDataProcessingJoinersCountryIntervalDriver}
     * @memberof MuDataProcessingJoinersCountryIntervalManual
     */
    driver: MuDataProcessingJoinersCountryIntervalDriver;
}

export function MuDataProcessingJoinersCountryIntervalManualFromJSON(json: any): MuDataProcessingJoinersCountryIntervalManual {
    return MuDataProcessingJoinersCountryIntervalManualFromJSONTyped(json, false);
}

export function MuDataProcessingJoinersCountryIntervalManualFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingJoinersCountryIntervalManual {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driver': MuDataProcessingJoinersCountryIntervalDriverFromJSON(json['driver']),
    };
}

export function MuDataProcessingJoinersCountryIntervalManualToJSON(value?: MuDataProcessingJoinersCountryIntervalManual | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver': MuDataProcessingJoinersCountryIntervalDriverToJSON(value.driver),
    };
}


